// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"72":"069fca1a","198":"10a52655","477":"4344f724","627":"84cee09c","663":"f6d65291","777":"8dd401b9","803":"2d06f152","820":"6366db9b"}[chunkId] + ".chunk.js";
};